import { render, staticRenderFns } from "./input-text-area.vue?vue&type=template&id=a37c21aa&"
import script from "./input-text-area.vue?vue&type=script&lang=js&"
export * from "./input-text-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports